import { Box, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { ModalCadastroCooperativa } from 'components/ModalCadastroCooperativa';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, downloadDocumentoCooperativa, openModal } from 'store/modules/EscolasActions';
import UseProgramas from '../../../../../hooks/useCooperativa';
import { ModalRemoveCoop } from '../Modal/ModalRemoveCoop';
import './index.scss';
import languageValues from 'utils/LanguageUtils';
import { ListaCooperativaProps } from '../Modal/ModalAddCoop/DocumentCoop/__types';
import MoreVertIcon from 'components/Icons/MoreVertIcon';
import { RootState } from 'store';
import useCadastroSteps from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useEscolaSteps';
import NewDownloadIcon from 'assets/icons/NewDownloadIcon';
import AccordionArrowOpenClose from 'assets/icons/AccordionArrowOpenClose';
import { TipoPrograma } from '../../../../../__enum';
import { useHabilitaCampoPrograma } from '../../../../../hooks/useDisablePrograma';

export const ListaCooperativa: React.FC<ListaCooperativaProps> = ({
  coopList,
  openModalCooperative,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const [selectedCoopId, setSelectedCoopId] = useState<number | null>(null);
  const { handleCoopDelete, handleDownloadLink } = UseProgramas();
  const { classeCondicional, isDesabilitado } = useHabilitaCampoPrograma(TipoPrograma.CooperativaEscolar);
  const { handleTipoDocumentoFetch } = useCadastroSteps();
  const tipoDocumentoCoop = useSelector((state: RootState) => state.escolas.tipoDocumentoCoop);
  const dispatch = useDispatch();

  const toggleExpand = (id: number) => {
    setExpandedId(prev => (prev === id ? null : id));
  };
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, coopId: number) => {
    setAnchorEl(event.currentTarget);
    setSelectedCoopId(coopId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedCoopId(null);
  };

  const handleEdit = () => {
    const coop = coopList.find((c) => c.id === selectedCoopId);
    if (coop) openModalCooperative(coop);
    handleClose();
  };

  const handleRemove = () => {
    if (selectedCoopId !== null) {
      dispatch(
        openModal(
          <ModalCadastroCooperativa
            title={languageValues.pages.escolas.modals.removerCoopModal.title}
            content={
              <ModalRemoveCoop
                onCancel={() => dispatch(closeModal())}
                onConfirm={() => handleCoopDelete(selectedCoopId)}
              />
            }
            open={true}
            close={() => dispatch(closeModal())}
          />
        )
      );
    }
    handleClose();
  };

  useEffect(() => {
    if (tipoDocumentoCoop.length === 0) {
      handleTipoDocumentoFetch();
    }
  }, [handleTipoDocumentoFetch, tipoDocumentoCoop.length]);

  const handleDownload = async (path: string) => {
    if (path) {
      dispatch(
        downloadDocumentoCooperativa(path, (resp) => {
          const file = new File([resp.data], path, { type: 'application/pdf' });
          handleDownloadLink(file);
        })
      );
    }
  };

  return (
    <div className='table-container'>
      <table>
        <thead>
          <tr>
            <th className={classeCondicional}>Nome da Cooperativa</th>
            <th className={classeCondicional}>Data de Fundação</th>
            <th className={classeCondicional}>Documentos</th>
            <th className={classeCondicional}>Ações</th>
            <th className={classeCondicional}></th>
            <th className={classeCondicional}></th>
            <th className={classeCondicional}></th>
            <th className={classeCondicional}></th>
          </tr>
        </thead>
        <tbody>
          {coopList.map((coop) => (
            <React.Fragment key={coop.id}>
              <tr className={classeCondicional}>
                <td className={`td ${classeCondicional}`}>{coop.nome}</td>
                <td className={`td ${classeCondicional}`}>{coop.dataFundacao}</td>
                <td className={`td ${classeCondicional}`}>{coop.documentacoes.length}</td>
                <td className={`td ${classeCondicional}`}>
                  <IconButton onClick={(e) => handleMenuClick(e, coop.id)} className={classeCondicional}>
                    <MoreVertIcon />
                  </IconButton>
                  <IconButton onClick={() => toggleExpand(coop.id)} className={classeCondicional}>
                    <AccordionArrowOpenClose
                      style={{
                        fill: '#33820D',
                        transform: expandedId === coop.id ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s',
                      }}
                    />
                  </IconButton>
                </td>
                <td className={`td`}></td>
                <td className={`td`}></td>
                <td className={`td`}></td>
                <td className={`td`}></td>
              </tr>

              {expandedId === coop.id && (
                <tr>
                  <td colSpan={5} style={{ padding: 0 }}>
                    <Box className="accordion__details">
                      <Box className="accordion__details-item">
                        <Box className="accordion__details-title">Documentos</Box>
                        {coop.documentacoes.map((doc) => {
                          const tipoDoc = tipoDocumentoCoop.find((tipo) => tipo.tipo === doc.tipo);
                          return (
                            <Box key={doc.id} className="accordion__details-doc">
                              <Typography className="accordion__details-doc-name">
                                {tipoDoc?.nome}
                              </Typography>
                              <IconButton onClick={() => handleDownload(doc.caminho)} size="small">
                                <NewDownloadIcon color="#33820D" />
                              </IconButton>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem disabled={isDesabilitado} onClick={handleEdit} className='menu-item'>Editar</MenuItem>
        <MenuItem disabled={isDesabilitado} onClick={handleRemove} className='menu-item'>Excluir</MenuItem>
      </Menu>
    </div>
  );
};
